import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import Sizes, { IPickerSize } from 'src/view/components/Controls/Sizes/Sizes';
import SizesSkeleton from 'src/view/components/Controls/Sizes/SizesSkeleton';
import { IResponseProductSize } from '~/types/products';

const ProductSizes: React.FC = observer((): JSX.Element | null => {
  if (!orderProductModalStore.product) return <SizesSkeleton className="mb-2" />;

  const sizes = useMemo((): IPickerSize<IResponseProductSize>[] => {
    if (!orderProductModalStore.product?.sizes?.length) return [];
    return orderProductModalStore.product.sizes.map((size) => ({ value: size, name: size.name, key: size.id }));
  }, [orderProductModalStore.product?.sizes]);

  if (orderProductModalStore.product.type) return null;

  return (
    <Sizes selected={orderProductModalStore.product?.size?.id} options={sizes} onChange={orderProductModalStore.onChangeSize} className="mb-2" />
  );
});

export default ProductSizes;
